import { render, staticRenderFns } from "./Portnoy.vue?vue&type=template&id=0c80ee78&scoped=true&"
import script from "./Portnoy.vue?vue&type=script&lang=js&"
export * from "./Portnoy.vue?vue&type=script&lang=js&"
import style0 from "./Portnoy.vue?vue&type=style&index=0&id=0c80ee78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c80ee78",
  null
  
)

export default component.exports